{
  "confirmationNumber": "確認番号 {number}",
  "dateTimeRange": "{date} {startTime}～{endTime}"
}
